module.exports = __webpack_public_path__ + "img/008.f21da074.jpg";